import React, { useState } from "react";
import { Spin, Button, Col, Form, Row, notification } from "antd";
import { usePersonalDataStore, useProfileStore } from "../../pages/auth/authStore";
import { useCountriesAndData } from "../../base/hooks/useCountriesAndData";
import AuthService from "../../base/services/authentication.service";
import { httpService } from "../../base/services/httpService.service";
import { LocalStorageService } from "../../base/services/local-storage.service";
import ProfileInformationSection from "./ProfileInformationSection";
import LocationSection from "./LocationSection";
import CompanyInformationSection from "./CompanyInformationSection";

const PersonalInformation = React.memo(({ handleUserData }) => {
   const personalData = usePersonalDataStore((state) => state.personalData);
   const setPersonalData = usePersonalDataStore((state) => state.setPersonalData);
   const user = AuthService.getUser();
   const organizationId = AuthService.getOrganizationId();
   const [form] = Form.useForm();
   const { countries } = useCountriesAndData(form);
   const { isLoading, formData } = useProfileStore();
   const [isSavingData, setIsSavingData] = useState(false);

   const updatePersonalInformation = (values) => {
      setIsSavingData(true);
      const payload = {
         userId: user.id,
         userFullName: values.userFullName,
         gender: values.gender,
         userRoleWithinOrganization: values.userRoleWithinOrganization,
         userPhoneNumber: values.userPhoneNumber,
         userCountryId: values.userCountryId,
         geographicalDetail: {
            governorateOrProvince: values.governorateOrProvince, //state
            district: values.district,
            subdistrict: values.subdistrict,
            cityOrCampOrVillage: values.cityOrCampOrVillage, //city
            neighborhoodOrSector: values.neighborhoodOrSector, //Village/Neighborhood
            houseOrTentDetails: values.houseOrTentDetails //Address line
         },
         organizationId: organizationId,
         organizationName: values.organizationName,
         organizationTypeId: values.organizationTypeId,
         organizationCountryId: values.organizationCountryId,
         zipCode: values.zipCode
      };

      httpService
         .post(`/Organizations/editUserAndOrganization`, payload, (response) => {
            if (!response) return;
            LocalStorageService.setItem("organizationName", values.organizationName);
            LocalStorageService.setItem("user", { ...user, fullName: values.userFullName });
            handleUserData();
            notification.open({
               type: "success",
               message: response.data.message || "Your information has been updated successfully."
            });
            setPersonalData({
               ...personalData,
               fullName: values.userFullName
            });
         })
         .catch((error) => {
            notification.error({
               message: error.response?.data?.message || "Something went wrong. Please try again."
            });
         })
         .finally(() => {
            setIsSavingData(false);
         });
   };

   return (
      <>
         {isLoading ? (
            <Spin
               style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "50px"
               }}
            ></Spin>
         ) : (
            <Form
               form={form}
               className="personalInformation"
               initialValues={formData}
               onFinish={updatePersonalInformation}
               autoComplete="off"
               layout="vertical"
            >
               <ProfileInformationSection />

               <LocationSection form={form} />

               <CompanyInformationSection countries={countries} />

               <Row gutter={16} className="mt-8" align="middle">
                  <Col>
                     <Button htmlType="submit" className="primaryButton" loading={isSavingData}>
                        Save changes
                     </Button>
                  </Col>
               </Row>
            </Form>
         )}
      </>
   );
});

export default PersonalInformation;
